import { Flex, useColorMode, FlexProps } from '@chakra-ui/react'

export const Container = (props: FlexProps) => {
  const { colorMode } = useColorMode()

  const bgColor = { light: 'white', dark: 'gray.900' }

  const color = { light: 'black', dark: 'white' }
  const style ={paddingTop: 90};


  return (
    <Flex
      direction="column"
      alignItems="stretch"
      justifyContent="flex-start"
      textAlign="left"
      bg={bgColor[colorMode]}
      color={color[colorMode]}
      style={style}
      {...props}
    />
  )
}
